import { useMutation, useQueryClient } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { APIError } from '../../../utils'
import { disconnectPayNow } from '../query-api'

interface UseDisconnectPayNowProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export const useDisconnectPayNow = ({ onError, onSuccess }: UseDisconnectPayNowProps = {}) => {
  const queryClient = useQueryClient()

  const {
    mutate: disconnect,
    isLoading: isProcessing,
    ...rest
  } = useMutation(disconnectPayNow, {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKeys.PayNowStatus])
      onSuccess?.()
    },
    onError,
  })

  return { disconnect, isProcessing, ...rest }
}
